import { Grid, IconButton } from '@mui/material';
import React from 'react';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { ADD_ONS_DETAILS } from 'components/pages/Register/RegisterConfig';
import { useTranslation } from 'react-i18next';

export default function NewCustomerDialog(props) {
  const { t: tCommon } = useTranslation('common');
  const { handleClose, countryConfig, addonData, purchaseAddonHandler, purchaseData } = props;
  const addonDetails = ADD_ONS_DETAILS[addonData?.key];

  const handleSelectSalesPack = (addon) => {
    purchaseAddonHandler(addon);
    handleClose();
  };

  const getAddonContainerSelectStyle = (pack) => {
    const addon = purchaseData.add_ons.find((adn) => adn?.key === addonDetails.key && adn?.count === pack.count);
    return addon ? styles.selectedPackContainer : '';
  };

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper} style={{ padding: 10 }}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tCommon('Select a {{name}} pack', { name: addonDetails.name.toLowerCase() })}</h2>
          <IconButton onClick={handleClose} className={styles.closeBtn}><CloseIcon /></IconButton>
        </div>
        <div className={styles.inputSec}>
          <Grid container spacing={2}>
            <Grid xs={12}>
              <p className={styles.subText}>{addonDetails.note}</p>
            </Grid>
            {Object.values(addonData?.config?.variants || {}).map((pack) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={styles.packWrapper}
                onClick={() => {
                  handleSelectSalesPack([{ key: addonDetails.key, count: pack.count }]);
                }}
              >
                <Grid className={`${styles.packCotainer} ${getAddonContainerSelectStyle(pack)}`}>
                  <img src={addonDetails?.image} alt={tCommon('Sanoft POS Addons – best billing software and best billing app for small businesses')} />
                  <Grid className={styles.headContainer}>
                    <h3>{pack?.count}</h3> <span className={styles.subText}>{tCommon('Sales')}</span>
                  </Grid>
                  <p>
                    {tCommon('{{count}} {{name}} add to your shop.', { count: pack?.count, name: addonDetails.name.toLowerCase() })}
                  </p>
                  <h3>
                    {countryConfig?.currency || '₹'}
                    {pack?.price}
                  </h3>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </div>
  );
}
